/**
 * Accumulate a page of tag-search results for the "View All" infinite scroll.
 *
 * offset === 0  -> new search: replace with this page.
 * offset  >  0  -> append.
 *
 * A single running-Set dedupe pass by ROW identity (`id`, falling back to
 * `video_id`) handles the duplicate source we actually have — the stale/double
 * re-append (offset-race, Virtuoso double-`endReached`, StrictMode) drops the SAME
 * row twice. `id` is the row's own id: `vs.id` (per segment) in segment mode,
 * `vp.id` (per video) in the video branch — unique per row in BOTH.
 *   - offset 0 = new search -> start from an empty base (replace).
 *   - offset > 0 -> accumulate onto `prev`.
 * Keying on the ROW id (NOT `video_id`) is deliberate: the "Search by segment"
 * toggle returns one row per matching moment — same `video_id`, distinct `id` — and
 * those must be KEPT, not collapsed. Because the Set updates AS we walk the page, an
 * exact-duplicate row is dropped even within a single page. (Per-video collapse where
 * it IS wanted — the video branch and the spell-suggestion fallback — is done in SQL.)
 */
export function mergeSearchPage(prev, page, offset) {
    const rows = Array.isArray(page) ? page : [];
    const base = offset === 0 ? [] : (Array.isArray(prev) ? prev : []);
    const key = (x) => (x && (x.id ?? x.video_id));
    const seen = new Set(base.map(key));
    const out = [...base];
    for (const x of rows) {
        if (!x) continue;
        const k = key(x);
        if (seen.has(k)) continue;
        seen.add(k);
        out.push(x);
    }
    return out;
}
